import { render, staticRenderFns } from "./InvoiceManageAdd.vue?vue&type=template&id=4f54700c&scoped=true"
import script from "./InvoiceManageAdd.vue?vue&type=script&lang=js"
export * from "./InvoiceManageAdd.vue?vue&type=script&lang=js"
import style0 from "./InvoiceManageAdd.vue?vue&type=style&index=0&id=4f54700c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54700c",
  null
  
)

export default component.exports